import { createAction, createSlice } from '@reduxjs/toolkit';

export const updateProfileRequest = createAction('whatsappProfile/updateProfileRequest');
export const loadPhoneProfileRequest = createAction('whatsappProfile/loadPhoneProfileRequest');

const initialState = {
    phoneProfile: {
        displayName: '',
        displayNamePending: null,
        displayPhoneNumber: '',
        category: '',
        description: '',
        address: '',
        email: '',
        websites: [],
        imageUrl: null,
        phoneNumberId: '',
        wabaId: ''
    },
    loading: false,
    success: false,
    phoneProfileLoading: false,
    phoneProfileError: null,
    phoneProfileLoaded: false
};

const whatsappProfileSlice = createSlice({
    name: 'whatsappProfile',
    initialState,
    reducers: {
        updateProfileStart(state) {
            state.loading = true;
            state.success = false;
        },
        updateProfileSuccess(state, action) {
            state.loading = false;
            state.success = true;
            state.phoneProfile = { ...state.phoneProfile, ...action.payload };
        },
        updateProfileFailure(state, action) {
            state.loading = false;
            state.success = false;
        },
        loadPhoneProfileStart(state) {
            state.phoneProfileLoading = true;
            state.phoneProfileError = null;
        },
        loadPhoneProfileSuccess(state, action) {
            state.phoneProfileLoading = false;
            state.phoneProfileLoaded = true;
            state.phoneProfileError = null;
            state.phoneProfile = action.payload;
        },
        loadPhoneProfileFailure(state, action) {
            state.phoneProfileLoading = false;
            state.phoneProfileError = action.payload;
        },
        resetProfileState(state) {
            state.loading = false;
            state.success = false;
        },
        resetPhoneProfileState(state) {
            state.phoneProfileLoading = false;
            state.phoneProfileError = null;
            state.phoneProfileLoaded = false;
        }
    }
});

export const {
    updateProfileStart,
    updateProfileSuccess,
    updateProfileFailure,
    loadPhoneProfileStart,
    loadPhoneProfileSuccess,
    loadPhoneProfileFailure,
    resetProfileState,
    resetPhoneProfileState
} = whatsappProfileSlice.actions;

export default whatsappProfileSlice.reducer;